module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/1_75ae58602b2a9f2b748bafc4c90fe531.png";